import type { DropdownOption } from "@comp-lib/components/CustomDropdown.vue";
import currencyData from "@/assets/currencies.json";

interface CurrencyInfo {
  name: string;
  symbol: string;
}

const currencies = currencyData as Record<string, CurrencyInfo>;

export const currencyOptions: DropdownOption[] = Object.entries(currencies).map(
  ([code, { name, symbol }]) => ({
    value: code,
    label: `${code} - ${name} (${symbol})`
  })
);

export const DEFAULT_CURRENCY = "USD";
